var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuPersonIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_314",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9861 0.256592H0V24.2566H23.9861V0.256592Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.256592H23.9861V24.2566H0V0.256592ZM1 23.2566H22.9861V1.25659H1V23.2566Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_314)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9925 3.75859C9.85534 3.75859 8.1228 5.49113 8.1228 7.62832C8.1228 9.76552 9.85534 11.4981 11.9925 11.4981C14.1297 11.4981 15.8623 9.76552 15.8623 7.62832C15.8623 5.49113 14.1297 3.75859 11.9925 3.75859ZM6.6228 7.62832C6.6228 4.6627 9.02691 2.25859 11.9925 2.25859C14.9582 2.25859 17.3623 4.6627 17.3623 7.62832C17.3623 10.5939 14.9582 12.9981 11.9925 12.9981C9.02691 12.9981 6.6228 10.5939 6.6228 7.62832Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91305 16.0935C8.20221 16.0935 7.49833 16.2336 6.84165 16.5058C6.18498 16.778 5.58838 17.1769 5.08595 17.6797C4.58352 18.1826 4.18512 18.7795 3.91352 19.4365C3.64192 20.0934 3.50244 20.7974 3.50305 21.5082C3.50341 21.9224 3.16792 22.2585 2.7537 22.2589C2.33949 22.2592 2.00341 21.9237 2.00305 21.5095C2.00227 20.6016 2.18042 19.7024 2.52733 18.8633C2.87424 18.0243 3.3831 17.2618 4.02483 16.6195C4.66656 15.9772 5.42858 15.4677 6.26733 15.1201C7.10608 14.7725 8.00512 14.5935 8.91305 14.5935H15.0731C15.981 14.5935 16.88 14.7725 17.7188 15.1201C18.5575 15.4677 19.3195 15.9772 19.9613 16.6195C20.603 17.2618 21.1119 18.0243 21.4588 18.8633C21.8057 19.7024 21.9838 20.6016 21.9831 21.5095C21.9827 21.9237 21.6466 22.2592 21.2324 22.2589C20.8182 22.2585 20.4827 21.9224 20.4831 21.5082C20.4837 20.7974 20.3442 20.0934 20.0726 19.4365C19.801 18.7795 19.4026 18.1826 18.9002 17.6797C18.3977 17.1769 17.8011 16.778 17.1445 16.5058C16.4878 16.2336 15.7839 16.0935 15.0731 16.0935H8.91305Z",
    fill: "#1C1C1C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPersonIcon2);
export default __webpack_public_path__ + "static/media/menu-person-icon-2.9168dafe7950edebcd07643d7d6c1e5f.svg";
export { ForwardRef as ReactComponent };